import gsap from 'gsap'

// ANIMATION TIMELINES FOR ALL THE PAGES ON DESKTOP
export const homeAnimationTimline = () =>
  gsap
    .timeline({ defaults: { duration: 0.5, ease: 'power1.inOut' } })
    .set('.home-screen', { visibility: 'visible' })
    .to('.home-screen-body', { y: 0, autoAlpha: 1 })
    .pause()

export const workAnimationTimeline = () =>
  gsap
    .timeline({ defaults: { duration: 0.65, ease: 'power1.inOut' } })
    .set('.work-screen', { visibility: 'visible' })
    .to('.work-screen-backgrounds-back', { x: 0, autoAlpha: 1 })
    .to('.work-screen-backgrounds-front', { x: 0, autoAlpha: 1 }, 0.15)
    .to('.work-screen-body', {
      autoAlpha: 1,
      duration: 0.3,
    })
    .pause()

export const educationAnimationTimeline = () =>
  gsap
    .timeline({ defaults: { duration: 0.5, ease: 'power1.inOut' } })
    .set('.educ-screen', { visibility: 'visible' })
    .to('.educ-body', { y: 0, autoAlpha: 1 })
    .pause()

export const contactmeAnimationTimeline = () =>
  gsap
    .timeline({ defaults: { duration: 0.5, ease: 'power1.inOut' } })
    .set('.contact-screen', { visibility: 'visible' })
    .to('.contact-body', { y: 0, autoAlpha: 1 })
    .pause()

// ANIMATION TIMELINES FOR ALL THE PAGES ON MOBILE
export const homeAnimationTimlineMobile = () =>
  gsap
    .timeline({
      defaults: {
        duration: 0.45,
        ease: 'power1.inOut',
      },
    })
    .set('.home-screen', { visibility: 'visible' })
    .to('.home-screen-body', { autoAlpha: 1 }, 0)
    .pause()

export const workAnimationTimelineMobile = () =>
  gsap
    .timeline({ defaults: { duration: 0.65, ease: 'power1.inOut' } })
    .set('.work-screen', { visibility: 'visible' })
    .to('.work-screen-backgrounds-back', { x: 0, autoAlpha: 1 })
    .to('.work-screen-backgrounds-front', { y: 0, autoAlpha: 1 }, 0.3)
    .to('.work-screen-body', {
      autoAlpha: 1,
      duration: 0.25,
    })
    .pause()

export const educationAnimationTimelineMobile = () =>
  gsap
    .timeline({ defaults: { duration: 0.45, ease: 'power1.inOut' } })
    .set('.educ-screen', { visibility: 'visible' })
    .to('.educ-body', { y: 0, autoAlpha: 1 })
    .pause()

export const contactmeAnimationTimelineMobile = () =>
  gsap
    .timeline({ defaults: { duration: 0.45, ease: 'power1.inOut' } })
    .set('.contact-screen', { visibility: 'visible' })
    .to('.contact-body', { y: 0, autoAlpha: 1 })
    .pause()

// OTHER ANIMATION TIMELINES
export const flyAnimation = (el) => {
  gsap
    .timeline({ defaults: { duration: 0.45, ease: 'power1.inOut' } })
    .to(el, { x: 40, y: -40 })
    .set(el, { x: -40, y: 40 })
    .to(el, { x: 0, y: 0 })
}
